import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const ActionsBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 4px;
  line-height: 20.8px;
`

export const Description = styled.div`
  font-size: 16px;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 8px;
  line-height: 24px;
`
